import { createSlice } from "@reduxjs/toolkit";
import { errMsg } from "../../components/etc/errMsg";
const initialState = {
  modalMsg: { type: "", msg: "" },
  validatePage: "",
  errorCode: "",
  signUpInfo_eulas: {
    eulaAge: false,
    eulaTerms: false,
    eulaPrivacy: false,
    eula3rd: false,
    eulaMarketing: false,
  },
  signUpInfo: {},
  userInfo: { email: "", name: "" },
  loginPending: false,
  loginSuccess: false,
  loginFailure: false,
  logoutPending: false,
  logoutSuccess: false,
  logoutFailure: false,
  signUpPending: false,
  signUpSuccess: false,
  signUpFailure: false,
  authCheckPending: false,
  authCheckSuccess: false,
  authCheckFailure: false,
  authCheckList: {
    email: false,
    phone: false,
  },
  sendEmailConfirmPending: false,
  sendEmailConfirmSuccess: false,
  sendEmailConfirmFailure: false,
  withdrawalPending: false,
  withdrawalSuccess: false,
  withdrawalFailure: false,
  reSettingPasswordPending: false,
  reSettingPasswordSuccess: false,
  reSettingPasswordFailure: false,
};
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    showMsg: (state, payload) => {
      state.modalMsg = {
        msg: payload.payload.msg,
        type: payload.payload.type,
      };
    },
    checkPagePathname: (state, payload) => {
      state.validatePage = payload.payload;
    },
    // **로그인 **
    fetchLogin: (state) => {
      state.loginPending = true;
      state.loginSuccess = false;
      state.loginFailure = false;
      state.modalMsg = {
        type: "",
        msg: "",
      };
    },
    fetchLoginSuccess: (state, { payload }) => {
      state.loginPending = false;
      state.loginSuccess = true;
      state.loginFailure = false;
    },
    fetchLoginFailure: (state, { payload }) => {
      state.loginPending = false;
      state.loginSuccess = false;
      state.loginFailure = true;
      state.modalMsg = {
        type: "",
        msg: payload.response.data.message,
      };
    },

    // **로그아웃 **
    fetchLogout: (state) => {
      state.logoutPending = true;
      state.logoutSuccess = false;
      state.logoutFailure = false;
    },
    fetchLogoutSuccess: (state, { payload }) => {
      state.logoutPending = false;
      state.logoutSuccess = true;
      state.logoutFailure = false;
    },
    fetchLogoutFailure: (state, { payload }) => {
      state.logoutPending = false;
      state.logoutSuccess = false;
      state.logoutFailure = true;
    },
    resetSignUpInfo: (state) => {
      state.signUpInfo_eulas = {
        eulaAge: false,
        eulaTerms: false,
        eulaPrivacy: false,
        eula3rd: false,
        eulaMarketing: false,
      };
      state.signUpInfo = {};
    },
    agreeEula: (state, payload) => {
      state.signUpInfo_eulas = {
        ...state.signUpInfo_eulas,

        [payload.payload.name]: payload.payload.checked,
      };
    },
    allAgreeEula: (state, payload) => {
      state.signUpInfo_eulas = {
        ...state.signUpInfo_eulas,

        eulaAge: payload.payload,
        eulaTerms: payload.payload,
        eulaPrivacy: payload.payload,
        // eula3rd: payload.payload,
        eulaMarketing: payload.payload,
      };
    },
    setSignUpInfo: (state, payload) => {
      // console.log(payload.payload);
      state.signUpInfo = payload.payload;
    },

    // **회원가입 **
    fetchSignUp: (state) => {
      state.signUpPending = true;
      state.signUpSuccess = false;
      state.signUpFailure = false;
      state.modalMsg = {
        type: "",
        msg: "",
      };
    },
    fetchSignUpSuccess: (state, { payload }) => {
      state.signUpPending = false;
      state.signUpSuccess = true;
      state.signUpFailure = false;
      state.signUpInfo_eulas = {
        eulaAge: false,
        eulaTerms: false,
        eulaPrivacy: false,
        eula3rd: false,
        eulaMarketing: false,
      };
      state.signUpInfo = {};
    },
    fetchSignUpFailure: (state, { payload }) => {
      // console.log(payload.response.data.message);
      // state.modalMsg = {
      //   type: "func",
      //   msg: errMsg.signUp[payload.response.data.code],
      // };
      state.modalMsg = {
        type: "",
        msg: payload.response.data.message,
      };
      state.signUpPending = false;
      state.signUpSuccess = false;
      state.signUpFailure = true;
    },

    // **회원 중복체크 **
    fetchAuthCheck: (state, { payload }) => {
      state.authCheckPending = true;
      state.authCheckSuccess = false;
      state.authCheckFailure = false;
      state.authCheckList = {
        ...state.authCheckList,
        [payload.params.input]: false,
      };

      state.modalMsg = {
        type: "",
        msg: "",
      };
    },
    fetchAuthCheckSuccess: (state, { payload }) => {
      state.authCheckPending = false;
      state.authCheckSuccess = true;
      state.authCheckFailure = false;
      state.authCheckList = {
        ...state.authCheckList,
        [payload.params.params.input]: true,
      };
    },
    fetchAuthCheckFailure: (state, { payload }) => {
      // console.log(payload);
      state.authCheckPending = false;
      state.authCheckSuccess = false;
      state.authCheckFailure = true;
      state.authCheckList = {
        ...state.authCheckList,
        [payload.params.params.input]: false,
      };
      if (payload.params.params.input == "email") {
        state.sendEmailConfirmPending = false;
        state.sendEmailConfirmSuccess = false;
        state.sendEmailConfirmFailure = true;
        state.authCheckList = {
          ...state.authCheckList,
          email: false,
        };
      }
      state.modalMsg = {
        type: "",
        msg: payload.err.response.data.message,
      };
    },
    // **이메일 인증 요청 **
    fetchSendEmailConfirm: (state) => {
      state.sendEmailConfirmPending = true;
      state.sendEmailConfirmSuccess = false;
      state.sendEmailConfirmFailure = false;
      state.modalMsg = {
        type: "",
        msg: "",
      };
    },
    fetchSendEmailConfirmSuccess: (state, { payload }) => {
      state.sendEmailConfirmPending = false;
      state.sendEmailConfirmSuccess = true;
      state.sendEmailConfirmFailure = false;
    },
    fetchSendEmailConfirmFailure: (state, { payload }) => {
      state.sendEmailConfirmPending = false;
      state.sendEmailConfirmSuccess = false;
      state.sendEmailConfirmFailure = true;
      state.authCheckList = {
        ...state.authCheckList,
        email: false,
      };
      state.modalMsg = {
        type: "",
        msg: payload.response.data.message,
      };
    },

    // **회원탈퇴 **
    fetchWithdrawal: (state) => {
      state.withdrawalPending = true;
      state.withdrawalSuccess = false;
      state.withdrawalFailure = false;
    },
    fetchWithdrawalSuccess: (state, { payload }) => {
      state.withdrawalPending = false;
      state.withdrawalSuccess = true;
      state.withdrawalFailure = false;
    },
    fetchWithdrawalFailure: (state, { payload }) => {
      state.withdrawalPending = false;
      state.withdrawalSuccess = false;
      state.withdrawalFailure = true;
    },

    ////비밀번호 재설정(본인인증 이후, 로그인 못한 상태)
    fetchReSettingPassword: (state) => {
      state.reSettingPasswordPending = true;
      state.reSettingPasswordSuccess = false;
      state.reSettingPasswordFailure = false;
      state.modalMsg = {
        type: "",
        msg: "",
      };
    },
    fetchReSettingPasswordSuccess: (state, { payload }) => {
      state.reSettingPasswordPending = false;
      state.reSettingPasswordSuccess = true;
      state.reSettingPasswordFailure = false;
      state.modalMsg = {
        type: "func",
        msg: errMsg.reSettingPassword["success"],
      };
    },
    fetchReSettingPasswordFailure: (state, { payload }) => {
      state.reSettingPasswordPending = false;
      state.reSettingPasswordSuccess = false;
      state.reSettingPasswordFailure = true;
      state.modalMsg = {
        type: "",
        msg: errMsg.reSettingPassword["error"],
      };
    },
  },
});

// 정의한 액션과 리듀서를 export한다.
export const authActions = authSlice.actions;
export default authSlice;
